<template>
    <div class="margin-bottom" style="position: relative">
        <div class="div-preloader" ref="preloader">
            <div class="div-status"></div>
        </div>

        <div class="page-title statistics-global-filter">
            <div class="box no-border">
                <div class="box-header">
                    <span class="statistics-global-filter__label" v-html="config.filters.statistic.filter_label"></span>
                    <statistic-filter :config="config.filters.statistic" :active-stat="activeStat"></statistic-filter>

                    <span class="statistics-global-filter__label" v-html="config.filters.consultant.filter_label"></span>
                    <consultant-filter :config="config.filters.consultant"></consultant-filter>
                    <consultant-level-filter :config="config.filters.consultant_level" v-show="activeStat.hasSelectConsultantLevelFilter"></consultant-level-filter>

                    <span class="statistics-global-filter__label" v-html="config.filters.group_by_consultant_level.filter_label" v-show="activeStat.hasGroupByConsultantLevelFilter"></span>
                    <group-by-consultant-level-filter :config="config.filters.group_by_consultant_level" v-show="activeStat.hasGroupByConsultantLevelFilter"></group-by-consultant-level-filter>
                    <div class="box-tools pull-right">
                        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                        </button>
                    </div>
                </div>
                <div class="box-body">
                    <statistic-component-filter v-for="statistic in config.statistics" v-bind:key="statistic.stat"
                        :statistic="statistic" v-show="activeStat.stat == statistic.stat" :active-stat="activeStat"
                    >

                    </statistic-component-filter>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import StatisticFilter from './global_filters/statistic.vue';
    import ConsultantFilter from './global_filters/consultant.vue';
    import ConsultantLevelFilter from './global_filters/consultantLevel.vue';
    import GroupByConsultantLevelFilter from './global_filters/groupByConsultantLevel.vue';
    import StatisticComponentFilter from './statisticComponentFilter.vue';

    export default {
        props: ['config', 'activeStat'],
        components: {
            'statistic-filter': StatisticFilter,
            'consultant-filter': ConsultantFilter,
            'consultant-level-filter': ConsultantLevelFilter,
            'group-by-consultant-level-filter': GroupByConsultantLevelFilter,
            'statistic-component-filter': StatisticComponentFilter,
        },
        data(){
            return {

            }
        },
        created() {
            this.selectedConsultantLevel = this.config.filters.consultant_level.options[0];

            Event.$on('statisticLoading', (loading) => {
                if(loading) {
                    $(this.$refs.preloader).show();
                }else{
                    $(this.$refs.preloader).hide();
                }
            });
        }

    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/statistics-super-commissions/partials/header.vue